// Stub for libphonenumber-js, which is pulled in by @cmpsr/components PhoneInput.
// We never render PhoneInput, so this empty module avoids bundling ~347 KB of phone metadata.
// These stub exports satisfy @maskito/phone's ESM named imports at build time.
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const parsePhoneNumber = () => {};
export const getCountryCallingCode = () => '';
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const validatePhoneNumberLength = () => {};
export class AsYouType {
  input() { return ''; }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getNumber() {}
}

const exports: Record<string, unknown> = {
  parsePhoneNumber,
  getCountryCallingCode,
  validatePhoneNumberLength,
  AsYouType,
};

const handler: ProxyHandler<Record<string, unknown>> = {
  get(target, prop) {
    if (import.meta.env.DEV && typeof prop === 'string' && prop !== '__esModule' && !(prop in target)) {
      console.error(`[shim] Attempted to use un-shimmed export "${prop}" from "libphonenumber-js". Add it to src/shims/libphonenumber-js-shim.ts.`);
    }
    return target[prop as string];
  },
};

export default new Proxy(exports, handler);
